import reset                 from 'styled-reset';
import { createGlobalStyle } from 'styled-components';
import { variables }         from './variables';

const BaseStyles = createGlobalStyle`
  ${reset}

  html, body, #root {
    width            : 100%;
    height           : 100%;
    background-color : ${variables.colors.lightGray};
    margin-left      : auto;
    margin-right     : auto;
    min-width        : 320px;
  }

  body {
    font-family    : 'Roboto', sans-serif;
    letter-spacing : 0.42px;
  }

  b {
    font-weight: 500;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition-delay: 99999s;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance : none;
    margin             : 0;
  }

  a {
    color           : ${variables.colors.secondary};
    text-decoration : underline;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }

  h1 {
    color         : ${variables.colors.secondary};
    font-size     : ${variables.spacing.lg};
    font-weight   : 500;
    margin-bottom : 10px;
    line-height   : ${variables.spacing.xl};
  }

  h2 {
    color         : ${variables.colors.secondary};
    font-size     : 20px;
    font-weight   : 500;
    margin-bottom : 5px;
    line-height   : ${variables.spacing.lg};
  }

  h3 {
    color       : ${variables.colors.red};
    font-size   : ${variables.spacing.sm};
    margin      : 10px 0;
    font-weight : 700;
  }

  h4 {
    color       : ${variables.colors.darkRed};
    font-size   : 14px;
    font-weight : 500;
  }

  .clearfix:after {
     content    : " "; /* Older browser do not support empty content */
     visibility : hidden;
     display    : block;
     height     : 0;
     clear      : both;
  }

  .grid-container {
    width  : 100% !important;
    margin : 0 !important;
  }
`;

export { BaseStyles };
